// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/Panel/Panel.sass
// module id = 422
// module chunks = 0